import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Segmented } from '@/shared/uikitV2/antd/Segmented';

export const Container = styled.div`
  position: relative;
  flex: 1;
`;

export const OverlayText = styled.p`
  position: absolute;
  top: 50%;
  left: 50%;
  translate: -50% -50%;
  z-index: 100;
  font-size: 18px;
  font-weight: 700;
  color: ${COLORS.systemDark300};
`;

export const Legend = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 4px;
  color: ${COLORS.systemDark200};
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Icon = styled.div<{ $bgColor: string }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ $bgColor }) => $bgColor};
  flex-shrink: 0;
`;

export const Value = styled.p`
  color: ${COLORS.systemDark300};
`;

export const DoughnutChartWrapper = styled.div`
  width: 144px;
  min-height: 144px;
  position: relative;
`;

export const StyledSegmented = styled(Segmented)`
  &&& {
    background: ${COLORS.systemLight300};
    color: ${COLORS.systemDark200};
    margin-bottom: 12px;
  }
`;

export const ContainerVertical = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 24px;
`;

export const VerticalLegend = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  color: ${COLORS.systemDark200};
  width: 100%;
  padding-top: 32px;
`;

export const LegendRow = styled.div`
  border-bottom: 1px solid ${COLORS.systemDark100};
  width: 100%;
  display: grid;
  grid-template-columns: 30px 2fr 1fr;
  align-items: center;
`;

export const LegendHeaderText = styled.b`
  color: ${COLORS.systemDark300};
  padding: 12px;

  &:last-of-type {
    text-align: right;
  }
`;

export const IconBean = styled.div`
  width: 6px;
  height: 16px;
  border-radius: 100px;
  flex-shrink: 0;
  margin: 12px;
`;

export const LegendText = styled.span`
  color: ${COLORS.systemDark300};
  padding: 12px;

  &:last-of-type {
    text-align: right;
  }
`;

export const VerticalBarChartWrapper = styled.div`
  width: 200px;
  height: 144px;
`;

export const LegendList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${COLORS.systemDark300};
  padding: 8px 0;
`;

export const LegendAmountText = styled.b`
  color: ${COLORS.systemDark300};
  align-self: flex-start;
  margin: 8px 12px 0 auto;
`;

export const TooltipText = styled.span`
  color: ${COLORS.systemDark300};
`;

export const LegendListTitle = styled.div`
  display: flex;
  align-items: center;
  font-weight: 700;
  gap: 4px;
`;
